var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image.phototype!=360)?_c('div',{style:({'background-image': 'url(\'' + _vm.getImagePath() + '\')'})}):_c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":'image_' + this.image.pdphotoid}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d172084","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/photoDocumentation/common/photodisplay.vue
// module id = null
// module chunks = 